<template>
  <div>
    <img src="../assets/probanner.jpg" class="img-fluid w-100" alt="newsbanner">
    <section class="feature-area">
      <div class="mbx">
        <div class="container">
          <div class="row">
            <div class="col-lg-9">
              <div class="nytit pull-left">搜索结果</div>
            </div>
            <div class="col-lg-3">
              <div class="mbxwrap">
                <router-link to="/" class="underline">首页</router-link> <span>/</span>
                <em>搜索结果</em>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

    <section class="feature-area paddingtop30 paddingbottom30">
      <div class="container">
        <div class="news">
          <ul>
            <li v-for="(list,index) in search_list">
                  <div class="pic pull-left"><a href="javascript:void(0);" @click="toProductDetails(list)"><img class="vcenter" :src="list.image" alt="" /></a></div>
                  <div class="ntxt pull-left">
                    <a href="javascript:void(0);"class="underline" @click="toProductDetails(list)"><div v-html="list.name + '('+list.menu+')'"/></a>
                    <p>{{list.decr}}</p>
                  </div>
<!--                <div class="col-lg-3">-->
<!--                  <div class="date">-->
<!--                    <span>{{list.updateTime}}</span>-->
<!--                    <a href="javascript:void(0);" @click="toNewsDetails(list)"></a>-->
<!--                  </div>-->
<!--                </div>-->
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="feature-area  paddingbottom30">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 ">
              <Pagination v-if="total != 0" style="float: right"
                          :page-no="pageNo"
                          :page-size="pageSize"
                          :total="total"
                          :continues="5"
                          @getPageNo="getPageNo"
              ></Pagination>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
  export default {
    data () {
      return {
        search_list: [],
        pageSize: 5,
        pageNo: 1,
        total: 0,
        text: this.$route.query.text,
      }
    },
    components: {
      Pagination,
    },
    methods:{

      getSearch(text, pageNo){
        const vm = this;
        vm.text = text;
        vm.pageNo = pageNo;
        console.log(vm.text)

        vm.$_axios({
          method: 'post',
          url: '/mapis/search/searchDocs',
          data: {
            text: vm.text,
            pageNo: vm.pageNo,
            pageSize: vm.pageSize
          },
          needLogin: false,
        }).then((response) => {
          if (response.status === 200) {
            const responseData = response.data.data;
            vm.search_list = responseData.docDtoList;
            vm.total = responseData.total;
          }
        });
      },

      getPageNo(pageNo) {
        const vm = this;
        vm.pageNo = pageNo;
        vm.getSearch(vm.text, vm.pageNo);
      },

      //获取产品详情
      toProductDetails(product){
        const vm = this;
        var list = product;
        console.log(list.name)
        if(list.desc != ''){
          list.name = list.name.replace('<font color=\'red\'>','').replace('</font>','');
          vm.$_storage.setLocalStore('product',list);
          vm.$router.push({name:'productDetails'});
        }else {
          this.$alert("未查询到产品信息");
        }
      },
    },
    mounted() {
      var vm = this;
      vm.getSearch(vm.text,1);
    }
  }
</script>




// WEBPACK FOOTER //
// Search.vue?3bfaf48d